function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

function selectVariant() {
    const selectedPhone = getCookie("selectedPhone");
    if (!selectedPhone) return;
    console.log(selectedPhone);
    var productForm = document.querySelector('form[is="product-form"]');
    const listbox = document.querySelector('.variant-picker x-listbox');
    if (!listbox) return;
    const options = listbox.querySelectorAll('[role="option"]');
    for (const option of options) {
        if (option.getAttribute('value') == selectedPhone) {
            if (productForm) {
                productForm.querySelector('input[name="id"]').value = option.getAttribute('data-id');
            }
            window.dispatchEvent(new CustomEvent('customVariantChanged', { detail: { variant: option.getAttribute('data-id') }  }));
            setTimeout(() => {
                option.click();}, 1);
            option.click();
            return;
        }
    }
}

document.addEventListener('DOMContentLoaded', selectVariant);
